<template>
  <div>
    <onaydialog ref="onaydialog"></onaydialog>


    <v-dialog scrollable="" persistent v-model="dialog" max-width="400px">
      <v-card flat color="grey lighten-3">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">  {{ $t('Visa-Type-Appointment') }}  </v-toolbar-title>
          <v-spacer></v-spacer>
         
        </v-toolbar>
        <v-card-text>

          <v-flex pb-2 xs12 sm12 md12>
            <v-card flat class="white--text">
              <v-card color="white" flat="">
                <v-card-actions>

                  <v-layout justify-space-between column>
                    <v-form ref="formek" v-model="valid" lazy-validation>
                      <v-layout row="" wrap="">


                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md9>
                              <v-select append-icon="search" :label="$t('Visa-List')"
                                :rules="[v => !!v || $t('Please-select-visa-type')]" v-model="VizeInput.VizeTipId"
                                :items="vizelistitems" :item-text="$t('Name_label')" item-value="Id" cache-items=""></v-select>
                            </v-flex>


                            <v-flex xs12 pt-2 sm4 md3>
                              <v-btn v-if="islem=='yeni'" flat @click="vizetipiEkle()" color="info">Yeni Ekle
                              </v-btn>
                              <!-- <v-btn v-if="islem=='guncelle'" flat @click="vizeGuncelle()" color="info">
                                {{ $t('Update') }}</v-btn> -->

                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-layout>
                    </v-form>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <div v-if="islem=='yeni'" class="flex md12">
            <v-data-table :headers="headersservis" :loading="progress" :items="items" hide-actions class="elevation-1">
              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <tr item>

                  <td class="text-xs-left">{{ props.item.VizeTip.isim }}</td>
                  <td class="justify-center layout px-0">
                    <v-tooltip bottom>
                      <v-btn icon small slot="activator" flat @click="vizetipisil(props.item)">
                        <v-icon small color="red">delete</v-icon>
                      </v-btn>
                      <span> {{ $t('Delete') }} </span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
                      <v-btn icon small slot="activator" flat @click="Getir(props.item)">
                        <v-icon small color="green">edit</v-icon>
                      </v-btn>
                      <span>Düzenle</span>
                    </v-tooltip> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="islem=='yeni'" color="primary" flat @click="dialog = false">
            {{$t('Close')}} </v-btn>
          <v-btn v-if="islem=='guncelle'" flat @click="islemiptal()" color="info">
            {{ $t('Cancel-Process') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>







    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tool from "../../coper/tools"
  import yuzdeinput from '../../customcomp/yuzdeinput'
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"


  export default {

    props: ["value"],
    components: {
      yuzdeinput,
      onaydialog
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      islemiptal() {
        this.islem = 'yeni'
        this.VizeInput.KDV = 0
        this.VizeInput.EkliSaticiKod = null
      },
      Getir(val) {
        this.vizelistitems = []

        var rec = {
          Ad: val.VizeTip.isim,
          Id: val.VizeTip.id,
        }

        this.islem = 'guncelle'

        this.vizelistitems.push(rec)

        this.VizeInput.VizeTipId = val.VizeTip.id

        this.silinecekkayit = val.id


        var params = {
          KonsoloslukKodu: this.Satici.Kod
        }

        tool.http_post(this, "VizeTipleriListKonsolosluk", params).then(
          response => {

            if (response.body.Status == true) {

              this.vizelistitems = response.body.data

            } else {

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        );



      },
      vizeGuncelle() {
        if (this.$refs.formek.validate()) {

          this.VizeInput.SaticiKodu = this.Satici.Kod


          var params = {
            EkliSaticiKod: this.VizeInput.SaticiKodu,
            KDV: this.VizeInput.KDV,
            Id: this.silinecekkayit
          }


          tool.http_post(this, "SaticiEkleriDegistir", params).then(
            response => {

              if (response.body.Status == true) {
                this.islem = 'yeni'

                this.VizeInput.KDV = 0
                this.VizeInput.EkliSaticiKod = null
                this.loadingacente = false
                var params = {
                  SaticiTipi: this.Satici.Tip,
                  SaticiKodu: this.Satici.Kod
                }


                tool.http_post(this, "SaticiEkleriList", params).then(
                  response => {

                    if (response.body.Status == true) {

                      this.items = response.body.data

                    } else {

                      this.text1 = 'Service Unavailable '
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable '
                    this.snackbar = true
                  }
                );

              } else {
                var str = ''
                response.body.ErrorList.forEach(element => {
                  str += element + ' , '
                });
                this.text1 = str
                this.snackbar = true
                this.loadingacente = false
              }
            },
            response => {
              this.text1 = 'Service Unavailable ara '
              this.snackbar = true
              this.loadingacente = false
            }
          );

        }
      },
      vizetipisil(val) {
        this.$refs.onaydialog.open("this.$t('Are-you-sure-you-want-to-delete-this-record')", 1).then(sonuc => {

          if (sonuc == true) {


            var params = {
              Id: val.Id
            }

            tool.http_post(this, "KonsoloslukVizeTipleriSil", params).then(
              response => {

                if (response.body.Status == true) {

                  var params = {
                    KonsoloslukKodu: this.Satici.Kod
                  }



                  tool.http_post(this, "VizeTipleriListKonsolosluk", params).then(
                    response => {



                      if (response.body.Status == true) {


                        this.vizelistitems = response.body.data

                      } else {

                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                      }
                    },
                    response => {

                      this.text1 = 'Service Unavailable'
                      this.snackbar = true
                    }
                  );


                  tool.http_post(this, "KonsoloslukVizeTipleriList", params).then(
                    response => {

                      if (response.body.Status == true) {

                        this.items = response.body.data

                      } else {

                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                      }
                    },
                    response => {

                      this.text1 = 'Service Unavailable'
                      this.snackbar = true
                    }
                  );


                } else {
                  var str = ''
                  response.body.ErrorList.forEach(element => {
                    str += element + ' , '
                  });
                  this.text1 = str
                  this.snackbar = true
                }
              },
              response => {
                this.text1 = 'Service Unavailable '
                this.snackbar = true
              }
            );


          }
        });
      },
      vizetipiEkle() {

        if (this.$refs.formek.validate()) {
          this.vizelistitems = []
          var params = {
            KonsoloslukKodu: this.Satici.Kod,
            VizeTipId: this.VizeInput.VizeTipId
          }

          tool.http_post(this, "KonsoloslukVizeTipleriEkle", params).then(
            response => {


              if (response.body.Status == true) {

                ///this.VizeInput.KDV = 0
                //this.VizeInput.EkliSaticiKod = null

                this.loadingacente = false


                var params = {
                  KonsoloslukKodu: this.Satici.Kod
                }



                tool.http_post(this, "VizeTipleriListKonsolosluk", params).then(
                  response => {


                    this.vizelistitems = []
                    if (response.body.Status == true) {


                      this.vizelistitems = response.body.data

                    } else {

                      this.text1 = 'Service Unavailable'
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                  }
                );


                tool.http_post(this, "KonsoloslukVizeTipleriList", params).then(
                  response => {

                    if (response.body.Status == true) {

                      this.items = response.body.data

                    } else {

                      this.text1 = 'Service Unavailable'
                      this.snackbar = true
                    }
                  },
                  response => {

                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                  }
                );


              } else {
                var str = ''
                response.body.ErrorList.forEach(element => {
                  str += element + ' , '
                });
                this.text1 = str
                this.snackbar = true
                this.loadingacente = false
              }
            },
            response => {
              this.text1 = 'Service Unavailable ara '
              this.snackbar = true
              this.loadingacente = false
            }
          );

        }
      },
      saticigetir(ara) {
        var params = {
          SaticiTipi: 11, //Acente
          Id: null, //eğer varsa ID, nokta atışı yapmak için. varsa 3. ve 4. parametreler işlevsiz kalır
          Kod: null, //eğer varsa Kod, Nokta atışı yapmak için. varsa 4. parametre işlevsiz kalır
          Aciklama: ara //Kullanıcının arama yapması için (maksimum 10 kayıt getirir)
        }

        tool.http_post(this, "SimpleSaticiAra", params).then(
          response => {

            if (response.body.Status == true) {
              this.vizelistitems = response.body.data
              this.loadingacente = false

            } else {
              this.text1 = 'Service Unavailable ara'
              this.snackbar = true
              this.loadingacente = false
            }
          },
          response => {
            this.text1 = 'Service Unavailable ara '
            this.snackbar = true
            this.loadingacente = false
          }
        );



      },
      onay() {
        this.dialog = false
        this.resolve(true);
      },
      iptal() {
        this.resolve(false);
        this.dialog = false
      },


      open(saticitip, saticikod, vizetip) {
        this.Satici.Kod = saticikod
        this.Satici.Tip = saticitip

        var params = {
          KonsoloslukKodu: saticikod
        }

        tool.http_post(this, "VizeTipleriListKonsolosluk", params).then(
          response => {

            if (response.body.Status == true) {

              this.vizelistitems = response.body.data

            } else {

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        );

        var params2 = {
          KonsoloslukKodu: this.Satici.Kod
        }

        tool.http_post(this, "KonsoloslukVizeTipleriList", params2).then(
          response => {

            if (response.body.Status == true) {

              this.items = response.body.data

            } else {

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        );

        this.dialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {

        vizetipleriitems: [{
            text: 'USA',
            value: 0
          },
          {
            text: 'CHANGEN',
            value: 1
          },
          {
            text: 'MUNFERIT',
            value: 2
          },
          {
            text: 'KONSOLOSLUK_OZEL',
            value: 3
          }
        ],
        islem: 'yeni',
        silinecekkayit: null,

        Satici: {
          Tip: null,
          Kod: null
        },
        valid: true,
        VizeInput: {
          KonsoloslukKodu: null,
          VizeTipId: null,

        },
        loadingsatici: false,
        vizelistitems: [],
        searchsatici: null,

        headersservis: [{
            text: 'Vize Tipi Adı',
            value: 'VizeTip.isim'
          },
          {
            text: '',
            value: '',

          }
        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialog: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {
      searchsatici(val) {
        // val && this.saticigetir(val)
      },

    },
  }




  function beforeMount() {



  }
</script>